<div class="d-flex align-items-{{ labelsVertical() ? 'start' : 'center' }} justify-content-between mb-3">
  <div>
    @if (fields()) {
      <app-base-inline-form
        [fields]="fields()"
        [model]="model()"
        [labelsVertical]="labelsVertical()"
        [marginBottom]="false"
      ></app-base-inline-form>
    }
  </div>

  @if (header()) {
    <h2 [class.header-top]="labelsVertical()">{{ header() }}</h2>
  }
</div>
